import React from 'react';
import PropTypes from 'prop-types';

class StackedBars extends React.Component {
  componentDidMount() {
    this.props.data.length && this.setSvg(this.props);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.data.length && this.setSvg(nextProps);
  }

  setSvg(props) {
    const { data, id, horizontal } = props;
    const horWidth = window.innerWidth < 710 ? 160 : 280;
    const horHeight = window.innerWidth < 710 ? 110 : 135;
    const svgSize = horizontal ? { width: horWidth, height: horHeight } : { width: 120, height: 280 };
    const varWidth = (44 * data.length) + svgSize.width;
    const margin = { top: 10, right: 10, bottom: horizontal ? 35 : 90, left: 60 };
    const width = varWidth - margin.left - margin.right;
    const height = svgSize.height - margin.top - margin.bottom;
    const causes = ['value', 'gap'];
    const tooltip = d3.selectAll('.c-tooltip-graph');
    let svg = d3.select('svg');
    let x;
    let y;

    // Remove svg to avoid append
    const svgEl = d3.select(`#${id} svg`)[0];
    svgEl[0] && svgEl[0].remove();

    const layers = d3.layout.stack()(causes.map((c) => (
      data.map((d) => ({ x: d.label, y: d[c] }))
    )));

    const yAxisOrientation = horizontal ? 'bottom' : 'left';
    const xAxisOrientation = horizontal ? 'left' : 'bottom';

    if (horizontal) {
      x = d3.scale.ordinal().rangeRoundBands([0, height], 0)
        .domain(layers[0].map((d) => d.x));

      y = d3.scale.linear().range([0, width], 0.05)
        .domain([0, 100]);
    } else {
      x = d3.scale.ordinal().rangeRoundBands([0, width], 0.05)
        .domain(layers[0].map((d) => d.x));

      y = d3.scale.linear().range([height, 0])
        .domain([0, 100]);
    }

    const xAxis = d3.svg.axis()
      .scale(x)
      .orient(xAxisOrientation);

    const yAxis = d3.svg.axis()
      .scale(y)
      .orient(yAxisOrientation)
      .innerTickSize(-width)
      .tickPadding(10)
      .ticks(5);

    const xAxisTransform = horizontal ? 0 : height;
    const yAxisTransform = horizontal ? height : 0;
    const xAxisTRanslate = window.navigator.msSaveBlob ? -50 : 0;

    svg = d3.select(`#${id}`).append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
    .append('g')
      .attr('transform', `translate(${margin.left} , ${margin.top})`);

    svg.append('g')
      .attr('class', 'axis x')
      .attr('transform', `translate(${xAxisTRanslate}, ${xAxisTransform})`)
      .call(xAxis)
      .selectAll('text')
      .style('text-anchor', horizontal ? 'center' : 'end')
      .attr('class', 'x-label')
      .attr('dx', (d, i) => {
        if (horizontal) return 0;
        return i === 0 ? 0 : -10;
      })
      .attr('dy', (d, i) => {
        if (horizontal) return -8;
        return i === 0 ? 15 : 5;
      })
      .attr('transform', horizontal ? 'rotate(0)' : 'rotate(-45)');

    svg.append('g')
      .attr('class', 'axis y')
      .attr('transform', `translate(0, ${yAxisTransform})`)
      .call(yAxis)
      .select('.domain')
      .remove();

    const layer = svg.selectAll('.layer')
      .data(layers)
      .enter()
        .append('g')
        .attr('class', (d, i) => d[i].x === 'Law' ? 'layer -value' : 'layer -gap');

    layer.selectAll('rect')
      .data((d) => d)
      .enter()
      .append('rect')
        .attr('x', (d, i) => {
          if (horizontal) return y(d.y0);
          return i === 0 ? x(d.x) + 40 : x(d.x) + 20;
        })
        .attr('y', (d) => horizontal ? x(d.x) : y(d.y + d.y0))
        .attr('class', (d) => d.x === 'Law' ? '-law' : '-practice')
        .attr('height', (d) => horizontal ? 20 : y(d.y0) - y(d.y + d.y0))
        .attr('width', (d) => horizontal ? y(d.y + d.y0) - y(d.y0) : 20)
        .on('mousemove', (d, i, z) => {
          const title = z === 0 ? d.x : 'Gap';

          tooltip
            .style('left', `${d3.event.pageX - 50}px`)
            .style('top', `${d3.event.pageY - 70}px`)
            .style('display', 'flex')
            .html(`<span class="title">${title}</span><span class="value">${d.y}</span>`);
        })
        .on('mouseout', () => tooltip.style('display', 'none'));
  }

  render() {
    return (
      <div id={this.props.id} className="c-stacked-bars"></div>
    );
  }
}

StackedBars.propTypes = {
  data: PropTypes.array,
  horizontal: PropTypes.bool,
  id: PropTypes.string
};

StackedBars.defaultProps = {
  horizontal: true
};

export default StackedBars;



// WEBPACK FOOTER //
// ./app/components/common/charts/StackedBars.jsx